'use strict';

/**
 * @deprecated
 */
function salaryQuestionnaireService($http, $interpolate) {
  var tokenURL = $interpolate('/api/salary/questionnaire-invite/{{token}}/');
  var summaryURL = $interpolate('/api/salary/questionnaire-invite/{{token}}/summary');

  return {
    retrieve: retrieve,
    retrieveSummary: retrieveSummary,
    complete: complete
  };

  function retrieve(token, step) {
    return $http.get(tokenURL({ token: token }), { params: { step: step } });
  }

  function retrieveSummary(token) {
    return $http.get(summaryURL({ token: token }));
  }

  function complete(token) {
    var data = { completed: true };
    return $http({ url: tokenURL({ token: token }), method: 'PATCH', data: data});
  }
}

module.exports = salaryQuestionnaireService;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/service/salary-questionnaire/index.js
 ** module id = 204
 ** module chunks = 0
 **/